import { useState } from 'react';
import { useTracking } from 'react-tracking';

import { Modal, Text, Grid } from '@simplywallst/ui-core';

import { supportedCurrencies } from '@/constants/currencies';
import type { CurrencyISO } from '@/constants/currencies';

import { Dropdown } from '@components/Dropdown';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { useChangePortfolioCurrencyMutation } from './hooks/useChangePortfolioCurrencyMutation';

export interface Props {
  portfolio: Portfolio;
  onClose: () => void;
}

const UpdatePortfolioCurrencyModal = ({ onClose, portfolio }: Props) => {
  const { trackEvent } = useTracking();
  const [portfolioCurrency, setNewPortfolioCurrency] = useState(
    portfolio.currencyISO
  );

  const { mutate, status: mutationStatus } = useChangePortfolioCurrencyMutation(
    {
      onSuccess() {
        onClose();
      },
    }
  );

  const handleClick = () => {
    trackEvent({
      action: 'click',
      modifier: 'changePortfolioCurrency',
    });
    mutate({
      id: portfolio.id,
      currency: portfolioCurrency,
    });
  };

  return (
    <Modal
      scrollable={false}
      title="Select a currency"
      primaryLabel="Save"
      secondaryLabel="Cancel"
      onSecondaryClick={onClose}
      onPrimaryClick={handleClick}
      primaryLoading={mutationStatus === 'pending'}
    >
      <Grid gap="24px">
        <Dropdown
          styleType="standardReverse"
          name="portfolioCurrency"
          label="Portfolio Currency"
          options={supportedCurrencies}
          value={portfolioCurrency}
          onSelect={(option: string) =>
            setNewPortfolioCurrency(option as CurrencyISO)
          }
        />
        <Text typography="tiny" color="spaceGrayRGBA" opacity={0.7}>
          All values will be converted in the new currency, except for stock
          prices.
        </Text>
      </Grid>
    </Modal>
  );
};

export default UpdatePortfolioCurrencyModal;
